export default __webpack_public_path__ + "static/media/default.78a8bcadb550179e372f2a9f173e4f11.png";